import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { PATH_CLIENT_EDIT, PATH_CLIENT_ACCOUNT_ADD, PATH_CLIENT_ACCOUNT_EDIT } from 'routing/path'
import PageHeader from 'components/page-header'
import ClientAccountSearchFilter from 'components/search-filters/client-account-search-filter'
import Table from 'components/table'
import { useGetAccountsQuery } from 'actions/client/client-account-api';
import { translationApi  } from 'actions/translation-api';
import { changePage  } from 'store/client/slice.account-list-filter';
import getUserStatusDescription from 'data/enums/user-status-enum';

const ClientAccountList = () => {
	const dispatch = useDispatch();
	const params = useParams();
	const clientIdString = params.id;

	const accountListFilter = useSelector(state => state.accountListFilter);
	const { data: accountList } = useGetAccountsQuery(accountListFilter, { refetchOnMountOrArgChange: true });
	const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

	const changeAccountListPage = (filterChange) => {
        dispatch(changePage(filterChange.page));
	}

	const getPageHeader = () => {
		let title = translations.accountList;
		const breadcrumbsCurrentPage = translations.accountList;
		let breadcrumbs = [];
		if (clientIdString && accountList?.clientName) {
			title = `${accountList.clientName} - ${translations.accountList}`;
			breadcrumbs = [
				{ name: `${translations.client} ${accountList.clientName}`, link: PATH_CLIENT_EDIT + clientIdString }
			]
		}
		const buttons = [<Link id="addClientAccountButton" key="addClientAccountButton" className="btn btn-primary me-2" to={PATH_CLIENT_ACCOUNT_ADD}>{translations.actionAddAccount}</Link>];

		return <PageHeader title={title} buttons={buttons} breadcrumbs={breadcrumbs} breadcrumbsCurrentPage={breadcrumbsCurrentPage} />
	}

	const pageHeader = getPageHeader();
	const headers = [translations.lastName, translations.firstName, translations.email, translations.status, translations.lastLoginDate, translations.invitationsSent, translations.lastInvitationDate];
	let rows = [];
	if (accountList && accountList.clientAccounts) {
		rows = accountList.clientAccounts.map(function (clientAccount) {
			return {
				link: PATH_CLIENT_ACCOUNT_EDIT + clientAccount.clientAccountId,
				columns: [clientAccount.lastName, clientAccount.firstName, clientAccount.email, getUserStatusDescription(clientAccount.status, translations), clientAccount.lastLoginDate, clientAccount.invitationsSent, clientAccount.lastInvitationDate]
			}
		});
	}
	
	return (
		<div>
			{pageHeader}
			<ClientAccountSearchFilter />
			<Table fetchList={changeAccountListPage} headers={headers} rows={rows} pagination={accountList?.pagination} translations={translations} />
		</div>
	);
}

export default ClientAccountList
